import { Injectable } from "@angular/core";
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { KYMW1002Model } from '../kymw1002.model';
import { KYMW00Model } from '../../../../commons/kymw00/kymw00.model';

/**
 * ダッシュボード画面 ロック情報（種別：画像）のロック解除をするサービス
 *
 * @export ReleaseImageLockService
 * @class ReleaseImageLock
 * @extends {PlessResponder}
 */
@Injectable()
export class ReleaseImageLockService extends PlessJsonResponderSub<any> {
  private model: KYMW1002Model;
  private successFunc: Function;
  private data: any;
  private index: any;
  private vo: any;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub,
    public sharedModel: KYMW00Model
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof ReleaseImageLockService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        ProcessName: this.vo.processName,
        UserId: this.vo.userId ? this.vo.userId.trim() : this.vo.userId
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param {KYMW1002Model} model モデルクラス
   * @param {number} index 解除対象行インデックス
   * @param {Function} successFunc 成功時後続処理
   * @memberof ReleaseImageLockService
   */
  execute(model: KYMW1002Model, index: number, vo: any, successFunc: Function): void {
    this.model = model;
    this.index = index;
    this.vo = vo;
    this.data = this.model.dashboardLockInfoList['LockInfoList'][this.index];
    this.successFunc = successFunc;
    this.send('releaseImageLock', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof ReleaseImageLockService
   */
  success(data: any): void {
    this.model.deleteLockInfo(this.index);

    if (data !== null) {
      this.successFunc();
    }
  }

  /**
   * API通信失敗時の処理
   *
   * @param {string} status エラーステータス
   * @param {*} result エラー結果
   * @memberof ReleaseImageLockService
   */
  exceptionError(status: string, result: any): void {
    super.exceptionError(status, result);
  }
}
